export async function preloadTemplates() {
  const templatePaths = [
    "modules/midi-qol/templates/activity-card.hbs",
    "modules/midi-qol/templates/attack-roll.html",
    "modules/midi-qol/templates/bonus-damage-roll.html",
    "modules/midi-qol/templates/damage-results.html",
    "modules/midi-qol/templates/damage-results-classic.html",
    "modules/midi-qol/templates/damage-results-player.html",
    "modules/midi-qol/templates/damage-results-player-classic.html",
    "modules/midi-qol/templates/damage-roll-dialog.hbs",
    "modules/midi-qol/templates/damage-roll.html",
    "modules/midi-qol/templates/dialog.hbs",
    "modules/midi-qol/templates/hits.html",
    "modules/midi-qol/templates/other-damage-roll.html",
    "modules/midi-qol/templates/roll-base.html",
    "modules/midi-qol/templates/roll-dialog.hbs",
    "modules/midi-qol/templates/roll.html",
    // "modules/midi-qol/templates/roll-options.html",
    "modules/midi-qol/templates/saves.html",
    "modules/midi-qol/templates/tool-card.hbs",
    "modules/midi-qol/templates/tooltip.html",
    "modules/midi-qol/templates/activity/attack-effect.hbs",
    "modules/midi-qol/templates/activity/check-effect.hbs",
    "modules/midi-qol/templates/activity/damage-effect.hbs",
    "modules/midi-qol/templates/activity/enchant-effect.hbs",
    "modules/midi-qol/templates/activity/heal-effect.hbs",
    "modules/midi-qol/templates/activity/save-effect.hbs",
    "modules/midi-qol/templates/activity/utility-effect.hbs",
    "modules/midi-qol/templates/activity/parts/attack-details.hbs",
    "modules/midi-qol/templates/activity/parts/attack-extras.hbs",
    "modules/midi-qol/templates/activity/parts/midi-activity-tab.hbs",
    "modules/midi-qol/templates/activity/parts/save-damage.hbs",
    "modules/midi-qol/templates/activity/parts/save-extras.hbs",
    "modules/midi-qol/templates/activity/parts/overtime-extras.hbs",
    "modules/midi-qol/templates/apps/ActorOnUseMacroConfig/actorOnUseMacrosConfig.hbs",
    "modules/midi-qol/templates/apps/ConditionEditor/conditionEditor.hbs",
    "modules/midi-qol/templates/apps/ConfigPanel/concentration.hbs",
    "modules/midi-qol/templates/apps/ConfigPanel/footer.hbs",
    "modules/midi-qol/templates/apps/ConfigPanel/gm.hbs",
    "modules/midi-qol/templates/apps/ConfigPanel/mechanics.hbs",
    "modules/midi-qol/templates/apps/ConfigPanel/misc.hbs",
    "modules/midi-qol/templates/apps/ConfigPanel/player.hbs",
    "modules/midi-qol/templates/apps/ConfigPanel/quick.hbs",
    "modules/midi-qol/templates/apps/ConfigPanel/reactions.hbs",
    "modules/midi-qol/templates/apps/ConfigPanel/rules.hbs",
    "modules/midi-qol/templates/apps/ConfigPanel/workflow.hbs",
    "modules/midi-qol/templates/apps/DependentsExplorer/dependentsExplorer.hbs",
    "modules/midi-qol/templates/apps/ItemOnUseMacrosConfig/itemOnUseMacrosConfig.hbs",
    "modules/midi-qol/templates/apps/OverTimeEditor/overTimeEditor.hbs",
    "modules/midi-qol/templates/apps/RollStatsDisplay/config.hbs",
    "modules/midi-qol/templates/apps/RollStatsDisplay/stats.hbs",
    "modules/midi-qol/templates/apps/SoundConfigPanel/quick.hbs",
    "modules/midi-qol/templates/apps/SoundConfigPanel/sounds.hbs",
    "modules/midi-qol/templates/apps/TargetConfirmation/targetConfirmation.hbs",
    "modules/midi-qol/templates/apps/TargetConfirmationConfig/targetConfirmationConfig.hbs",
    "modules/midi-qol/templates/apps/ModuleReviewDialog/moduleReview.hbs",
    "modules/midi-qol/templates/apps/TroubleShooter/common.hbs",
    "modules/midi-qol/templates/apps/TroubleShooter/errors.hbs",
    "modules/midi-qol/templates/apps/TroubleShooter/modules.hbs",
    "modules/midi-qol/templates/apps/TroubleShooter/problems.hbs",
    "modules/midi-qol/templates/apps/TroubleShooter/summary.hbs",
    "modules/midi-qol/templates/apps/UndoWorkflow/undo-workflow.hbs"
  ];
	return foundry.applications.handlebars.loadTemplates(templatePaths);
}
